import React from 'react'
import {  EditOutlined } from '@ant-design/icons'
import { Button, Space, Switch, Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'

import { Temple } from '@a4b/api/src/modules/Monetisation/Puja/types/templeTypes'

interface Props {
    data: Temple[]
    loading: boolean
    onEdit: (temple: Temple) => void
    onToggleActive: (temple: Temple, active: boolean) => void
}

const TempleListTable: React.FC<Props> = ({
    data,
    loading,
    onEdit,
    onToggleActive,
}) => {
    const columns: ColumnsType<Temple> = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Title (EN)',
            dataIndex: 'title_en',
            key: 'title_en',
        },
        {
            title: 'Title (HI)',
            dataIndex: 'title_hi',
            key: 'title_hi',
        },
        {
            title: 'Image',
            dataIndex: 'image',
            key: 'image',
            render: src => (
                <img
                    src={src}
                    alt='temple'
                    style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 4 }}
                />
            ),
        },
        {
            title: 'City',
            dataIndex: 'city',
            key: 'city',
        },
        {
            title: 'State',
            dataIndex: 'state',
            key: 'state',
        },
        {
            title: 'Status',
            dataIndex: 'active',
            key: 'active',
            render: (active, record) => (
                <Switch
                    checked={active}
                    onChange={checked => onToggleActive(record, checked)}
                />
            ),
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Button
                        type='primary'
                        icon={<EditOutlined />}
                        onClick={() => onEdit(record)}
                    >
                        Edit
                    </Button>
                </Space>
            ),
        },
    ]

    return (
        <Table
            columns={columns}
            dataSource={data}
            rowKey={(record, index) => `${record.id}-${index}`}
            loading={loading}
            pagination={false}
        />
    )
}

export default TempleListTable
